import React from "react";

import { Modal, Col, Form, Button } from 'react-bootstrap';

import { translatedMessage } from '../../../../services/language.service';

class EditGiftModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false         
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let giftReceiver = {
      name: event.target.elements.formName.value,
      email: event.target.elements.formEmail.value,
      sendNow: this.props.giftstatus === "true" ? true : event.target.elements.formStatus.checked
    }
    
    this.props.onHide(this.props.data.id, giftReceiver);
  }

  handleSendChange = (event) => {
    const input = event.currentTarget.querySelector('input')
    this.setState({
      checked: !input.checked
    })
  }

  render() {
    return (
      <Modal
        {...this.props}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" className="edit-modal-title">
            {translatedMessage("GIFT.SEND_AS_GIFT_TO")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: 'flex', flexDirection: 'column' }}>
          <Form id="giftForm" className="ca-form" onSubmit={this.handleSubmit}>
            <Form.Row>
              <Form.Group as={Col} md="12" controlId="formName">
                <Form.Label>
                  {translatedMessage("GENERAL.NAME")}
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  defaultValue={this.props.data.receiverName}
                  placeholder={translatedMessage("ARTWORK.SEND_GIFT.NAME_PLACEHOLDER")}
                />
              </Form.Group>
              <Form.Group as={Col} md="12" controlId="formEmail">
                <Form.Label>
                  {translatedMessage("GENERAL.EMAIL")}
                </Form.Label>
                <Form.Control
                  required
                  type="email"
                  defaultValue={this.props.data.receiverEmail}
                  placeholder={translatedMessage("ARTWORK.SEND_GIFT.EMAIL_PLACEHOLDER")}
                />
              </Form.Group>
              {this.props.giftstatus === "false" &&
                <Form.Group as={Col} md="12">
                  <div className="ca-check-container" onClick={this.handleSendChange}>
                    <input
                      type="checkbox"
                      id="formStatus"
                      checked={this.state.checked}
                      className="d-flex align-items-center"
                      onChange={this.handleSendChange}
                    />
                    <span className="ca-check-label">{translatedMessage("GIFT.SEND_NOW")}</span>
                    <span className="ca-checkmark"></span>
                  </div>
                </Form.Group>
              }
            </Form.Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className="ca-button mr-1" type="submit" form="giftForm">
            {translatedMessage("GENERAL.SAVE_CHANGES")}
          </Button>
          <Button variant="dark" className="ca-button ca-button-white" onClick={() => this.props.onHide(0, {})}>
            {translatedMessage("GENERAL.CLOSE")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default EditGiftModal;